var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncomeByStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1976d2",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.99951,208a4.0002,4.0002,0,0,1-4,4h-192a4.0002,4.0002,0,0,1-4-4V48a4,4,0,0,1,8,0V151.1875l57.36914-50.19775a3.99986,3.99986,0,0,1,5.03418-.18995l61.40528,46.05469,61.56054-53.86474a3.99981,3.99981,0,1,1,5.26758,6.0205l-64,56a3.99972,3.99972,0,0,1-5.03418.18995L96.19678,109.14551,35.99951,161.81738V204h188A4.0002,4.0002,0,0,1,227.99951,208Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeByStaff);
export default __webpack_public_path__ + "static/media/income_by_staff.ff90f68c1050973ab694f7e5a43a682f.svg";
export { ForwardRef as ReactComponent };